<div class="clear"></div>
<section class="banner">
    <div class="container py-4 d-flex justify-content-between align-items-center">
        <h1 class="mb-0">Legal Notices & Circulars</h1>
        <div class="input-group" style="max-width:300px;">
            <input type="text" class="form-control" [(ngModel)]="searchTerm" id="search" placeholder="search title...">
            <div class="input-group-append" id="button-addon4">
                <button class="btn btn-outline-secondary" type="button" (click)="ClearSearch()"><em
                        class="fas fa-backspace fa-fw"></em></button>
            </div>
        </div>
    </div>
</section>
<div class="clear py-3"></div>
<section class="container">

    <!-- #region Regulation 2011 -->
    <div *ngFor="let item of Records; let i = index">
        <h6 class="well font-weight-medium">
            <a data-toggle="collapse" [attr.href]="'#collapse' + i" role="button" aria-expanded="false"
                [attr.aria-controls]="'collapse' + i" class="d-flex w-100 align-items-center justify-content-between">
                <span>
                    <i class="far fa-hand-point-right text-primary mr-2"></i>
                    <ngx-highlight-words [textToHighlight]="item.Title" [searchWords]="[searchTerm]"
                        highlightClassName="bg-Searchable"></ngx-highlight-words>
                </span>
                <i class="fas fa-arrow-down fa-fw text-black-50"></i>
            </a>
        </h6>

        <div class="clearfix collapse" [attr.id]="'collapse' + i">
            <div class="d-flex justify-content-between">
                <h6 class="text-black">
                    <ngx-highlight-words [textToHighlight]="item.Title" [searchWords]="[searchTerm]"
                        highlightClassName="bg-Searchable"></ngx-highlight-words>
                </h6>
            </div>
            <div [innerHTML]="item.Description"></div>
        </div>
    </div>

    <!-- #region Regulation reg2010 -->
</section>
<div class="clear py-3"></div>